<template>
<div v-if="visible">
  <div v-for="(card,c) in cards" :key="c"> <ConnectedElement v-if="card.found || showAll" class="connectedElement"  dragHandle=".drag" :dragging="dragging"  :pos="{x:pos.x+offsetX+c*10,y:pos.y+offsetY+c*30}" :anchor="anchorParent" :width="cardWidth(card)" :height="cardHeight(card)" :index="c" :style="'z-index:'+zIndex(c)+';'">

       <component v-bind:is="compType" :card="card" :index="c" @click="doClick"  :selected="cardSelected(c)" @moveCardLeft="moveCardLeft" @moveCardTop="moveCardTop" @resetCardPos="resetCardPos">
       </component>
    </ConnectedElement></div>
  </div>
</template>

<script>
import ConnectedElement from "@/components/ConnectedElement.vue"
import VueDragResizeAndRotate from 'vue-drag-resize-and-rotate'

import ExpertCard from "@/components/ExpertCard.vue"
import DocumentCard from "@/components/DocumentCard.vue"
import EvidenceCard from "@/components/EvidenceCard.vue"
import EnvironmentCard from "@/components/EnvironmentCard.vue"
export default {
  components: {
    ConnectedElement,
    ExpertCard,
    DocumentCard,
    EnvironmentCard,
    EvidenceCard,
    VueDragResizeAndRotate
  },
  props: {
    index:null,
    cards:null,
    comp:null,
    parentNode:{ default:null},
    dragHandle:{type:String, default:null},
    pos:{type: Object,default: function () { return {x:100,y:0} }},
    anchor:{type: Object,default: function () { return {x:0,y:0} }},
    
  },
  data() {
    return {
      defaultCardWidth:200,
      defaultCardHeight:200,
      selectedCard:null,
      topCard:0,
      stack:[],
      dx:0,
      dy:0,
      ax:140,
      ay:75,
      offsetX:0,
      offsetY:0

    };
  },
  mounted(){
    //this.topCard=this.cards[this.cards.length-1]
    this.resetStack()
    
  },
  computed: {
    showAll(){
       return this.$store.getters.getPlayerAll
    },
    compType(){
      if(this.comp=="Experts"){
        return "ExpertCard"
      }else  if(this.comp=="Environment"){
        return "EnvironmentCard"
      }else  if(this.comp=="Evidence"){
        return "EvidenceCard"
      }else{
         return "DocumentCard"
      }
    },
    visible(){
    
       return this.parentNode.selected
    },
    offset(){
      return this.$store.getters.getNodeOffset(this.parentNode.index)
    },
    hasParent(){
      if(this.parentNode){
        return "PARENT"
      }else{
        return "NO PARENT"
      }
    },
    anchorParent(){
      if(this.parentNode ){
         return  {x:this.offset.x+this.parentNode.pos.x+this.ax,y:this.offset.y+this.parentNode.pos.y+this.ay}
   
         return  {x:this.parentNode.dx,y:this.parentNode.dy}
      }else{
       return  this.anchor
      }
    },
   connector1(){
      return {pt1:this.anchorParent,pt2:{x:this.pos.x+12+this.dx,y:this.pos.y+76+this.dy}}
    },
     
  },
  methods: {
    resetStack(){
      this.stack=[]
      for(var i=0;i<this.cards.length;i++){
        this.stack.push(i+100)
        this.topCard=i+100
      }
    },
    moveCardLeft(amt){
      this.offsetX-=amt
    },
    moveCardTop(amt){
      this.offsetY-=amt
    },
    resetCardPos(){
      this.offsetX=0
      this.offsetY=0
    },
    cardWidth(card){
      return card.width || this.defaultCardWidth
    },
    cardHeight(card){
      return card.height || this.defaultCardHeight
    },
    
    doClick(index){
      if(this.selectedCard==index && false){
        alert(this.stack[index])
        this.stack[index]=this.topCard-this.cards.length
        alert(this.stack[index])
        this.topCard-=2
        this.selectedCard=null
      }else{
        this.selectedCard=index
      this.topCard++
      this.stack[index]=this.topCard
      }
      
    },
    cardSelected(index){
      return index==this.selectedCard
    },
     zIndex(cardIndex){
      return this.stack[cardIndex]+10
    },
    dragging(params,target){
      this.dx=params.x
      this.dy=params.y
      if(this.selectedCard!=target.index){
        this.topCard++
        this.stack[target.index]=this.topCard
         this.selectedCard=target.index
      }
    },
  },
  watch:{
    visible(val){
      if(!val){
        this.resetStack()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
 @import "@/assets/sass/variables.scss";
//$border-blue:#00bbff;
.connectedElement{
    position: absolute;
    top: 0px;
    left: 0px;
    z-index:0;
    pointer-events: auto;
}

</style>
